import React, { memo } from 'react';
import { useIsomorphicLayoutEffect } from 'usehooks-ts';

import { Media } from '@interfaces/homepage';

import { buildLockedVideo } from '../../../../application/javascripts/videos/locked-player';
import { buildVideoPlayer } from '../../../../application/javascripts/videos/video-player';

interface VideoProps {
  canViewFullArticle: boolean;
  media: Media;
}

const Video = ({ canViewFullArticle, media }: VideoProps): JSX.Element => {
  useIsomorphicLayoutEffect(() => {
    const videoPlayer = document.querySelector('.video-player');
    const mediaOptions = {
      ...media,
      video: media?.video?.url,
    };

    if (!media.public && !canViewFullArticle) {
      buildLockedVideo(videoPlayer);
    } else {
      buildVideoPlayer(videoPlayer, mediaOptions);
    }
  }, [canViewFullArticle, media]);

  return (
    <figure className="featured-video mx-auto w-full max-w-container-lg">
      <div className="video-player aspect-[16/9]" data-testid="video-player">
        {media?.img?.url && <img src={media.img.url} className="h-auto w-full" />}
      </div>
    </figure>
  );
};

export default memo(Video);
